<template>
  <div class="lesson-wrapper">
    <basis-nav
      :nav-title="lesson.name"
      :back="back"
    />
    <template v-if="loading">
      <van-skeleton title :row="3" />
    </template>
    <template v-else>
      <span class="stage-name">{{ lesson.stageName }}</span>
      <div class="lesson-info">
        <h1 class="lesson-name">{{ lesson.name }}</h1>
        <div class="wrapper">
          <p class="teacher info">讲师：<span>{{ teacher.name }}</span></p>
          <p class="time info">时长：<span>{{ lesson.videoDuration | secondToDate }}</span></p>
          <p class="character-counts info">范字：<span>{{ lesson.charactersCount }}</span></p>
        </div>
      </div>
      <basis-video-player
        v-if="lesson.video"
        v-model="videoPlayer"
        class="video-player"
        :item="lesson"
        :cover-options="{
          aspectRatio: '16:9',
          controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            fullscreenToggle: true //全屏按钮
          }
        }"
        @playerReadied="onPlayerReadied"
      />
      <lazy-component
        v-else
        lazy-component
        class="lazy-component"
      >
        <van-image
          width="100%"
          height="100%"
          fit="fill"
          :src="lesson.cover"
        />
      </lazy-component>
      <div class="desc-wrapper" v-html="lesson.detail" />
      <div v-if="lesson.characters.length" class="characters-wrapper">
        <p class="title">范字精讲</p>
        <div class="character-list">
          <template v-for="item in lesson.characters">
            <character-card
              :key="item.name"
              :item="item"
              @clickHandler="clickCharacterCardHandler(item)"
            />
          </template>
        </div>
      </div>
      <basis-locked
        v-if="lesson.locked"
        support-vip
        :item="lesson"
        :locked-data="course"
      />
    </template>
  </div>
</template>

<script>
import { BasisNav, BasisLocked, BasisVideoPlayer } from '@/components/basis'
import CharacterCard from './components/CharacterCard'
import { Stages } from '@/api'
import { mapGetters } from 'vuex'

export default {
  name: 'Lesson',
  components: { BasisNav, BasisLocked, BasisVideoPlayer, CharacterCard },
  data: () => ({
    loading: true,
    videoPlayer: null,
    lesson: {
      characters: []
    }
  }),
  computed: {
    ...mapGetters(['teacher', 'course'])
  },
  async mounted () {
    try {
      const { id } = this.$route.params
      const { lesson } = await Stages.detail({ id })
      this.lesson = lesson
      this.loading = false
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    back () {
      const { teacherId, courseId } = this.$route.params
      this.$router.push({
        name: 'course-id',
        params: {
          teacherId,
          id: courseId
        }
      })
    },
    clickCharacterCardHandler (item) {
      const { id: courseId, teacherId } = this.$route.params
      const { id } = item
      this.$router.push({
        name: 'character-id',
        params: {
          id,
          courseId,
          teacherId
        },
        query: {
          return_to_url: this.$route.fullPath
        }
      })
    },
    // player is ready
    onPlayerReadied (player) {
      // seek to 10s
      player.currentTime(10)
    }
  }
}
</script>

<style scoped lang="scss">
.lesson-wrapper {
  .stage-name {
    @include sc($font-size-md, #fff);
    @include lg-radius(#E6AC67, #F5C993, 4px);
    display: inline-block;
    margin: 14px 14px 7px;
    padding: 7px;
  }
  .lesson-info {
    padding: 0 14px 22px;
    .lesson-name {
      @include sc($font-size-lg, $color-text-heavy);
      font-weight: 500;
      padding-bottom: 7px;
    }
    .wrapper {
      @include sc($font-size-md, $color-text-light);
      display: flex;
      justify-content: space-between;
      .info {
        span {
          color: $color-text-medium;
        }
      }
    }
  }
  .basis-video-player {
    width: 100%;
  }
  .lazy-component {
    @include wh(100%, calc(375px * 94 / 114));
    margin-bottom: 7px;
  }
  .desc-wrapper {
    @include sc($font-size-md, $color-text-heavy);
    @include lw(18px, 400);
    padding: 7px 14px;
  }
  .characters-wrapper {
    padding: 30px 14px;
    .title {
      @include sc($font-size-lg, $color-text-heavy);
      @include lw(18px, 600);
      position: relative;
      padding-bottom: 16px;
      &::before {
        @include wh(56px, 49px);
        @include bg-image-png('/courses/courses-bg');
        content: " ";
        background-size: cover;
        background-position: center;
        position: absolute;
        left: -7px;
        top: -20px;
      }
    }
    .character-list {
      display: grid;
      grid-template-columns: repeat(5, 60px);
      grid-row-gap: 10px;
      grid-column-gap: 10px;
    }
  }
}
</style>
